import React, { useEffect, useState } from "react";

import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import GroupSegregationSection from "./GroupSegregationSection";

const SCALE_OPTIONS = [
  { value: 1, label: "Discordo totalmente" },
  { value: 2, label: "Discordo" },
  { value: 3, label: "Neutro" },
  { value: 4, label: "Concordo" },
  { value: 5, label: "Concordo totalmente" },
];

export default function AgreeDisagreeInput({
  deleteComponent,
  rowId,
  colId,
  attributes,
  setAttributes,
  autoOpen = false,
  groups = [],
}) {
  const [ask, setAsk] = useState(
    attributes ? attributes.ask : "Texto da Pergunta",
  );
  const [isRequired, setIsRequired] = useState(
    attributes ? attributes.required : false,
  );
  const [editModal, setEditModal] = useState(false);
  // Segregação por grupos — se `groupIds` tiver itens, o campo só é
  // visível pros participantes desses grupos.
  const [groupIds, setGroupIds] = useState(attributes?.groupIds || []);

  useEffect(() => {
    if (autoOpen) setEditModal(true);
  }, []);

  useEffect(() => {
    if (!attributes) {
      setAttributes({
        rowId,
        colId,
        attributes: {
          ask: "Texto da Pergunta",
          required: false,
          inputName: "Texto da Pergunta",
        },
      });
    }
  }, [rowId, colId, setAttributes, attributes]);

  const submitForm = (e) => {
    e.preventDefault();
    setAttributes({
      rowId,
      colId,
      attributes: {
        ask,
        required: isRequired,
        inputName: ask,
        ...(groupIds.length > 0 ? { groupIds } : {}),
      },
    });
    setEditModal(false);
  };

  const renderScale = () => (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      {SCALE_OPTIONS.map((opt) => (
        <div
          key={opt.value}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            flex: 1,
          }}
        >
          <Input type="radio" disabled style={{ margin: "0 auto 4px" }} />
          <small
            style={{ textAlign: "center", fontSize: "10px", lineHeight: "1.2" }}
          >
            {opt.label}
          </small>
        </div>
      ))}
    </div>
  );

  return (
    <div className="custom-input-container">
      <Modal
        size="lg"
        isOpen={editModal}
        toggle={() => setEditModal(!editModal)}
        centered
      >
        <ModalHeader toggle={() => setEditModal(false)}>
          Configurar Escala de Concordância
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <Form>
                <FormGroup className="input-margin-btm">
                  <Label htmlFor="agree-ask" className="form-label">
                    Texto da Pergunta
                  </Label>
                  <Input
                    id="agree-ask"
                    className="form-control"
                    type="text"
                    value={ask}
                    onChange={({ target }) => setAsk(target.value)}
                  />
                </FormGroup>
                <FormGroup className="input-margin-btm">
                  <Input
                    className="input-mg-rgt"
                    type="checkbox"
                    id="agree-required"
                    checked={isRequired}
                    onChange={({ target }) => setIsRequired(target.checked)}
                  />
                  <Label htmlFor="agree-required" className="form-label">
                    Campo obrigatório?
                  </Label>
                </FormGroup>
              </Form>
              <GroupSegregationSection
                groups={groups}
                groupIds={groupIds}
                onChange={setGroupIds}
                fieldPrefix={`agreedisagreeinput-${rowId}-${colId}`}
              />
            </Col>
            <Col style={{ borderLeft: "1px solid gray" }}>
              <p className="mb-2">
                {ask}
                {isRequired && " *"}
              </p>
              {renderScale()}
            </Col>
          </Row>

          <div className="save-btn-form-container">
            <Button
              color="success"
              className="btn btn-success waves-effect waves-light save-btn-form"
              onClick={submitForm}
            >
              Salvar
            </Button>
          </div>
        </ModalBody>
      </Modal>
      <div className="displayed-config-container">
        <div
          className="displayed-label"
          style={{ width: "100%", flexDirection: "column" }}
        >
          <p className="mb-1">
            {ask}
            {isRequired && " *"}
          </p>
          {renderScale()}
        </div>
        <div className="config-form-icon">
          <span
            className="mdi mdi-cog-outline"
            onClick={() => setEditModal(!editModal)}
          />
          <span
            className="mdi mdi-close close-icon"
            onClick={() => deleteComponent(rowId, colId)}
          />
        </div>
      </div>
    </div>
  );
}
